import { useEffect } from 'react';
import SEOHead from '@/components/base/SEOHead';
import ScrollToTop from '@/components/base/ScrollToTop';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryTabs from './components/CategoryTabs';
import HotArticles from './components/HotArticles';
import FeaturedSection from './components/FeaturedSection';
import LatestArticles from './components/LatestArticles';
import CommunityStats from './components/CommunityStats';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '草榴技术讨论区',
    url: 'https://caoliu-tech.com/',
    description: '草榴技术讨论区是专注技术交流的核心社区板块，汇聚技术爱好者分享编程、网络、工具使用等实用经验。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://caoliu-tech.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '草榴技术讨论区',
    url: 'https://caoliu-tech.com/',
    description: '专注技术交流的核心社区板块',
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <SEOHead
        title="草榴技术讨论区 - 技术交流与资源分享平台"
        description="草榴技术讨论区是专注技术交流的核心社区板块，汇聚技术爱好者分享编程、网络、工具使用等实用经验。在草榴技术讨论区，你可以获取最新技术资讯、参与深度讨论、解决技术难题。"
        keywords="草榴技术讨论区,草榴技术板块,技术讨论社区,草榴论坛技术区,网络技术交流,工具技术分享,技术问答社区"
        canonicalUrl="https://caoliu-tech.com/"
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryTabs />
        <HotArticles />
        <FeaturedSection />
        <LatestArticles />
        <CommunityStats />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}